<mat-toolbar class="mc-toolbar-large" color="basic">
  <ng-container *ngIf="showItems">
    <ng-container *ngIf="itemCount >= 0">
      <span>{{ itemCount | mcPluralize : itemPluralize }}</span>
      <mat-divider [vertical]="true"></mat-divider>
    </ng-container>

    <span *ngIf="docSize >= 0">{{ docSize | mcFileSize }}</span>

    <ng-content></ng-content>

    <span class="mc-fill-remaining-flex-space"></span>
    <mat-icon fontSet="project-titan" fontIcon="icon-hamster" class="mc-toolbar-icon mc-image-icon-xxx-small"></mat-icon>
    &nbsp;
    <span class="mc-toolbar-text">
      Workspace
    </span>
  </ng-container>
</mat-toolbar>